// Module-level permission helpers (mirrors backend permissions.py)
export const hasModule = (user, key) =>
  !!user && (user.role === "super_admin" || (user.modules || []).includes(key));

// Ordered [moduleKey, path] — used to pick a landing page the user can access
export const ROUTE_ORDER = [
  ["dashboard", "/"],
  ["punch", "/punch"],
  ["my_profile", "/me"],
  ["employees", "/employees"],
  ["workers", "/workers"],
  ["field_staff", "/field-staff"],
  ["attendance", "/attendance"],
  ["leaves", "/leaves"],
  ["performance", "/performance"],
  ["payroll", "/payroll"],
  ["tada", "/tada"],
  ["increments", "/increments"],
  ["loans", "/loans"],
  ["designations", "/designations"],
  ["org_chart", "/org-chart"],
  ["locations", "/locations"],
  ["recruitment", "/recruitment"],
  ["exits", "/exits"],
  ["assets", "/assets"],
  ["vehicles", "/vehicles"],
  ["compliance", "/compliance"],
  ["reports", "/reports"],
  ["notifications", "/notifications"],
];

export const firstAllowedPath = (user) => {
  if (user?.role === "super_admin") return "/";
  for (const [key, path] of ROUTE_ORDER) {
    if (hasModule(user, key)) return path;
  }
  return null;
};
